import { render, staticRenderFns } from "./SignUpUserForm.vue?vue&type=template&id=0f61c619"
import script from "./SignUpUserForm.vue?vue&type=script&lang=js"
export * from "./SignUpUserForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpUserForm.vue?vue&type=style&index=0&id=0f61c619&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports